export default class extends HTMLElement {
  connectedCallback () {
  }

  get links () {
    return document.querySelectorAll('[data-role="app-link"]')
  }
}
